<template>
  <div class="app-container">
    <el-card shadow="never" class="query-card">
      <el-form :model="query" ref="queryForm" :inline="true" v-show="showSearch">
        <el-form-item label="任务名称" prop="jobName">
          <el-input
            v-model="query.jobName"
            placeholder="请输入任务名称"
            clearable
            size="small"
            style="width: 240px"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="任务分组" prop="jobGroup">
          <el-select
            v-model="query.jobGroup"
            placeholder="请选择任务分组"
            clearable
            size="small"
            style="width: 240px"
          >
            <el-option label="默认" value="DEFAULT" />
            <el-option label="同步" value="SYNC" />
            <el-option label="素材" value="MATERIAL" />
          </el-select>
        </el-form-item>
        <el-form-item label="执行状态" prop="status">
          <el-select
            v-model="query.status"
            placeholder="请选择状态"
            clearable
            size="small"
            style="width: 240px"
          >
            <el-option label="成功" value="0" />
            <el-option label="失败" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <table-operations
        :show-add="false"
        :show-delete="true"
        :disable-delete="multiple"
        @delete="handleDelete"
      >
        <el-button type="danger" plain icon="el-icon-delete" size="mini" @click="handleClean">清空</el-button>
        <el-button type="warning" plain icon="el-icon-close" size="mini" @click="handleClose">关闭</el-button>
        <template slot="right-toolbar">
          <right-toolbar :showSearch.sync="showSearch" @queryTable="fetchList"></right-toolbar>
        </template>
      </table-operations>

      <el-table v-loading="loading" :data="logList" @selection-change="handleSelectionChange" border>
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="日志编号" width="80" align="center" prop="jobLogId" />
        <el-table-column label="任务名称" align="center" prop="jobName" :show-overflow-tooltip="true" />
        <el-table-column label="任务分组" align="center" prop="jobGroup" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.jobGroup === 'DEFAULT'">默认</span>
            <span v-else-if="scope.row.jobGroup === 'SYNC'">同步</span>
            <span v-else-if="scope.row.jobGroup === 'MATERIAL'">素材</span>
            <span v-else>{{ scope.row.jobGroup }}</span>
          </template>
        </el-table-column>
        <el-table-column label="调用方法" align="center" prop="invokeTarget" :show-overflow-tooltip="true" />
        <el-table-column label="日志信息" align="center" prop="jobMessage" :show-overflow-tooltip="true" />
        <el-table-column label="执行状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === '0'" type="success" size="small">成功</el-tag>
            <el-tag v-else type="danger" size="small">失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="执行时长(ms)" align="center" prop="duration" width="120" />
        <el-table-column label="执行时间" align="center" width="180">
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-view" @click="handleView(scope.row)">详细</el-button>
            <el-button size="mini" type="text" icon="el-icon-delete" class="danger-text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="pageNo"
        :limit.sync="pageSize"
        @pagination="fetchList"
      />
    </el-card>

    <!-- 调度日志详细对话框 -->
    <el-dialog title="调度日志详细" :visible.sync="open" width="700px" append-to-body>
      <el-form :model="form" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="日志编号：">{{ form.jobLogId }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="任务名称：">{{ form.jobName }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="任务分组：">{{ form.jobGroup }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行时间：">{{ parseTime(form.createTime) }}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="调用方法：">{{ form.invokeTarget }}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="日志信息：">{{ form.jobMessage }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行状态：">
              <el-tag v-if="form.status === '0'" type="success" size="small">成功</el-tag>
              <el-tag v-else type="danger" size="small">失败</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行时长：">{{ form.duration }} ms</el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.status === '1' && form.exceptionInfo">
            <el-form-item label="异常信息：">
              <el-input v-model="form.exceptionInfo" type="textarea" :rows="5" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="open = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listJobLogs, getJobLog, deleteJobLogs, cleanJobLogs } from '@/api/system/job'
import Pagination from '@/components/Pagination'
import RightToolbar from '@/components/RightToolbar'
import TableOperations from '@/components/TableOperations'

export default {
  name: 'JobLog',
  components: { Pagination, RightToolbar, TableOperations },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 日志表格数据
      logList: [],
      // 总条数
      total: 0,
      // 详情弹出层
      open: false,
      // 非多个禁用
      multiple: true,
      // 选中数组
      ids: [],
      // 分页参数
      pageNo: 1,
      pageSize: 10,
      // 查询参数
      query: {
        jobName: undefined,
        jobGroup: undefined,
        status: undefined
      },
      // 所属任务 ID（从定时任务页面跳转携带）
      jobId: undefined,
      // 表单参数
      form: {}
    }
  },
  created() {
    const jobId = this.$route.query.jobId
    if (jobId) {
      this.jobId = jobId
    }
    this.fetchList()
  },
  methods: {
    /** 查询调度日志列表 */
    async fetchList() {
      this.loading = true
      try {
        const params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          jobId: this.jobId,
          ...this.query
        }
        const response = await listJobLogs(params)
        this.logList = response.data.records
        this.total = parseInt(response.data.total)
      } finally {
        this.loading = false
      }
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.pageNo = 1
      this.fetchList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.query = {
        jobName: undefined,
        jobGroup: undefined,
        status: undefined
      }
      this.jobId = undefined
      this.handleQuery()
    },
    /** 多选框选中数据 */
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.jobLogId)
      this.multiple = !selection.length
    },
    /** 详细按钮操作 */
    handleView(row) {
      getJobLog(row.jobLogId).then(response => {
        this.form = response.data
        this.open = true
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const logIds = row.jobLogId ? [row.jobLogId] : this.ids
      this.$confirm('是否确认删除日志编号为"' + logIds + '"的数据项？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteJobLogs(logIds)
        this.fetchList()
        this.$message.success('删除成功')
      }).catch(() => {})
    },
    /** 清空按钮操作 */
    handleClean() {
      this.$confirm('是否确认清空所有调度日志数据项？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await cleanJobLogs()
        this.fetchList()
        this.$message.success('清空成功')
      }).catch(() => {})
    },
    /** 关闭按钮（返回定时任务页面） */
    handleClose() {
      this.$router.push('/system/job')
    },
    /** 时间格式化 */
    parseTime(time) {
      if (!time) return ''
      const date = new Date(time)
      const y = date.getFullYear()
      const m = (date.getMonth() + 1).toString().padStart(2, '0')
      const d = date.getDate().toString().padStart(2, '0')
      const h = date.getHours().toString().padStart(2, '0')
      const min = date.getMinutes().toString().padStart(2, '0')
      const s = date.getSeconds().toString().padStart(2, '0')
      return `${y}-${m}-${d} ${h}:${min}:${s}`
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 0;
  background-color: #f8f8f9;
  min-height: calc(100vh - 84px);
}
.query-card {
  border: none;
}
.danger-text {
  color: #ff4d4f !important;
}
.danger-text:hover {
  color: #ff7875 !important;
}
</style>
